module.exports = __webpack_public_path__ + "media/application/images/ui/icon-footer-arrow-up-4f58c269de2fe0c107648aaa03af5f1d.png";